import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { setPageTitle } from 'actions/header';
import { clearForm, getForm, getFormInstance, getFormTemplate, updateFormInstance } from 'actions/templates';
import Redirect from 'components/Redirect/Redirect';
import SendDynamicForm from 'containers/Forms/SendDynamicForm';
import DisplayFormResults from 'containers/FormTemplate/Display/DisplayFormResults';
import FormInstance from 'containers/FormTemplate/Display/FormInstance';
import PreviewFormTemplate from 'containers/FormTemplate/Display/PreviewFormTemplate';
import Modal from 'containers/Modals/Modal';
import Moment from 'moment';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { DataList, Spinner } from 'UI';
import Block, { BlockContent, BlockWrapper } from 'UI/Elements/Block';
import RowItem, { RowCell } from 'UI/Elements/List/RowItem';
import DateTime from '_class/DateTime';

var SingleForm = /*#__PURE__*/function (_Component) {
  _inherits(SingleForm, _Component);

  var _super = _createSuper(SingleForm);

  /* Class setup */
  function SingleForm(props) {
    var _this;

    _classCallCheck(this, SingleForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.loadForm();
    });

    _defineProperty(_assertThisInitialized(_this), "loadForm", function () {
      _this.props.getForm(_this.props.match.params.id).then(function () {
        var promises = [];

        if (_this.props.user.id != _this.props.form.creator) {
          var instanceId = _this.props.form.formInstances[0].id;
          promises = [_this.props.getFormInstance(instanceId), _this.props.getFormTemplate(_this.props.form.formTemplateID)];
        } else {
          promises = [_this.props.getFormTemplate(_this.props.form.formTemplateID)];
        }

        _this.props.setPageTitle(_this.props.form.title);

        Promise.all(promises).then(function () {
          _this.setState({
            loading: false
          });
        });
      })["catch"](function () {
        _this.setState({
          notFound: true,
          loading: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.props.clearForm();
    });

    _defineProperty(_assertThisInitialized(_this), "toggleModal", function () {
      _this.setState({
        modal: !_this.state.modal
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAbort", function (reload) {
      if (reload) {
        _this.loadForm();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onInstanceClick", function (instance) {
      _this.props.getFormInstance(instance.id).then(function () {
        _this.setState({
          formInstance: instance
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeFormInstance", function () {
      _this.setState({
        formInstance: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderFormInstance", function (instance) {
      var edited = new DateTime(instance.edited);
      return /*#__PURE__*/React.createElement(RowItem, {
        key: instance.id,
        style: {
          cursor: 'pointer'
        },
        onClick: function onClick() {
          instance.status == 'SUBMITTED' ? _this.onInstanceClick(instance) : null;
        }
      }, /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('recipient')
      }, instance.user.firstName, " ", instance.user.lastName), instance.assigneeViewedCount != null ? /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('opened')
      }, instance.assigneeViewedCount) : null, /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('last-updated')
      }, instance.status == 'SUBMITTED' ? edited.getLongDateWithTime() : ''), /*#__PURE__*/React.createElement(RowCell, {
        shrink: true,
        title: _this.props.translate('turned-in')
      }, instance.status == 'SUBMITTED' ? _this.props.translate('turned-in') : _this.props.translate('not-turned-in')));
    });

    _this.state = {
      modal: false,
      formInstance: null,
      loading: true,
      loadingFormInstance: false
    };
    return _this;
  }
  /* Lifecycle methods */


  _createClass(SingleForm, [{
    key: "isIframe",
    value:
    /* Helper methods */
    function isIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    }
    /* Render methods */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (!this.props.services.forms) {
        return /*#__PURE__*/React.createElement(Redirect, {
          to: "/"
        });
      }

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      } else if (this.state.notFound) {
        return /*#__PURE__*/React.createElement("div", {
          className: "single-task"
        }, /*#__PURE__*/React.createElement("h3", null, this.props.translate('not-found')));
      }

      var _this$props = this.props,
          translate = _this$props.translate,
          formTemplate = _this$props.formTemplate,
          form = _this$props.form,
          formInstance = _this$props.formInstance;

      var turnedIn = _toConsumableArray(this.props.form.formInstances).filter(function (x) {
        return x.status == 'SUBMITTED';
      }).length;

      return /*#__PURE__*/React.createElement("div", {
        className: "single-task"
      }, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.modal,
        onClose: function onClose() {
          return _this2.toggleModal();
        },
        title: this.props.translate('forms')
      }, /*#__PURE__*/React.createElement(SendDynamicForm, null)), /*#__PURE__*/React.createElement(Modal, {
        overridePrompt: true,
        isOpen: formInstance != null,
        type: "small",
        onClose: this.closeFormInstance,
        title: translate('answers')
      }, /*#__PURE__*/React.createElement(DisplayFormResults, {
        fields: formTemplate.fields,
        instance: this.state.formInstance
      })), /*#__PURE__*/React.createElement("div", {
        className: "single-section form left-side",
        style: {
          paddingTop: 0
        }
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, form.text)), this.props.user.id == form.creator ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1.25rem',
          marginBottom: '1.25rem'
        }
      }, /*#__PURE__*/React.createElement(DataList, {
        renderRow: this.renderFormInstance,
        data: form.formInstances,
        title: this.props.translate('recipient')
      })) : null, /*#__PURE__*/React.createElement(BlockWrapper, {
        cols: "1"
      }, this.props.user.id == form.creator ? /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement(BlockContent, null, /*#__PURE__*/React.createElement("h2", {
        style: {
          marginBottom: '1rem'
        }
      }, translate('preview')), /*#__PURE__*/React.createElement(PreviewFormTemplate, {
        fields: formTemplate.fields
      }))) : /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement(BlockContent, null, Moment().isAfter(form.dueDate) ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", null, this.props.translate('your-answers')), /*#__PURE__*/React.createElement(DisplayFormResults, {
        fields: formTemplate.fields
      })) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", null, this.props.translate('answers')), /*#__PURE__*/React.createElement(FormInstance, {
        form: 'cm-' + formTemplate.id,
        fields: this.props.instance.formTemplate.fields,
        instance: this.props.instance,
        onAbort: this.onAbort
      })))))), /*#__PURE__*/React.createElement("div", {
        className: "single-actions right-side"
      }, /*#__PURE__*/React.createElement("div", {
        className: "action-section"
      }, /*#__PURE__*/React.createElement("h3", null, "Information"), this.props.user.id == form.creator ? /*#__PURE__*/React.createElement("div", null, turnedIn, " / ", form.formInstances.length, " ", this.props.translate('turned-in')) : /*#__PURE__*/React.createElement("div", null, turnedIn > 0 ? this.props.translate('turned-in') : this.props.translate('not-turned-in'))), form.dueDate != null ? /*#__PURE__*/React.createElement("div", {
        className: "action-section"
      }, /*#__PURE__*/React.createElement("h3", null, this.props.translate('last-answer-day')), new DateTime(form.dueDate).getLongDate()) : null, /*#__PURE__*/React.createElement("div", {
        className: "action-section"
      }, this.props.user.id != form.creator && Moment().isBefore(form.dueDate) && turnedIn < 1 ? /*#__PURE__*/React.createElement("span", null) : null), this.props.user.id == form.creator ? /*#__PURE__*/React.createElement("div", {
        className: "action-section"
      }, /*#__PURE__*/React.createElement("h3", null, translate('tools')), /*#__PURE__*/React.createElement(Link, {
        to: "#",
        onClick: function onClick() {
          return _this2.toggleModal('edit');
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "button button-target"
      }, translate('Edit')))) : null), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }));
    }
  }]);

  return SingleForm;
}(Component);

function mapStateToProps(state) {
  return {
    services: state.Services.availableServices,
    translate: translate(state.Languages.translations),
    formTemplate: state.Templates.formTemplate,
    form: state.Templates.form,
    user: state.user.currentUser,
    instance: state.Templates.instance
  };
}

export default connect(mapStateToProps, {
  setPageTitle: setPageTitle,
  getFormTemplate: getFormTemplate,
  getForm: getForm,
  updateFormInstance: updateFormInstance,
  getFormInstance: getFormInstance,
  clearForm: clearForm
})(SingleForm);